import {FormatOptionLabelMeta} from 'react-select';

import {OptionTypeBase} from '../../../types/OptionTypeBase';

type FormatOptionStyle = {
  fontSize: string;
  fontWeight: number;
  lineHeight: string;
  fontStyle?: string;
  color?: string;
};

const FORMAT_VALUE_STYLES: Record<string, FormatOptionStyle> = {
  h1: {fontSize: '22px', fontWeight: 700, lineHeight: '28px'},
  h2: {fontSize: '18px', fontWeight: 700, lineHeight: '24px'},
  h3: {fontSize: '16px', fontWeight: 600, lineHeight: '22px'},
  blockquote: {fontSize: '14px', fontWeight: 400, lineHeight: '20px', fontStyle: 'italic'},
};

const QUOTE_SEPARATOR_STYLE = {
  margin: '4px 0',
  border: 'none',
  borderTop: '1px solid #d4d4d8',
} as const;

const QUOTE_LABEL_STYLE = {
  display: 'block' as const,
  paddingLeft: '8px',
  borderLeft: '2px solid #a1a1aa',
  fontSize: '14px',
  fontWeight: 400,
  lineHeight: '20px',
  fontStyle: 'italic' as const,
};

export function formatFormatOptionLabel<ValueType>(
  option: OptionTypeBase<ValueType>,
  {context}: FormatOptionLabelMeta<OptionTypeBase<ValueType>>
) {
  if (context === 'value') {
    return option.label;
  }

  const value = typeof option.value === 'string' ? option.value : undefined;

  if (value === 'blockquote') {
    return (
      <>
        <hr style={QUOTE_SEPARATOR_STYLE} />
        <span style={QUOTE_LABEL_STYLE}>{option.label}</span>
      </>
    );
  }

  const style = value ? FORMAT_VALUE_STYLES[value] : undefined;

  if (!style) {
    return option.label;
  }

  return <span style={{display: 'block', ...style}}>{option.label}</span>;
}
